/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'share': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 19.92',
    data: '<path pid="0" d="M15 14.08a2.912 2.912 0 0 0-1.96.77L5.91 10.7A3.274 3.274 0 0 0 6 10a3.274 3.274 0 0 0-.09-.7l7.05-4.11A2.987 2.987 0 0 0 15 6a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3.274 3.274 0 0 0 .09.7L5.04 7.81A2.987 2.987 0 0 0 3 7a3 3 0 0 0-3 3 3 3 0 0 0 3 3 2.987 2.987 0 0 0 2.04-.81l7.12 4.16a2.82 2.82 0 0 0-.08.65A2.923 2.923 0 0 0 15 19.92 2.923 2.923 0 0 0 17.92 17 2.923 2.923 0 0 0 15 14.08z" fill-rule="evenodd"/>'
  }
})
